import React, { useState, useCallback, useMemo } from "react";
import { css } from "glamor";
import { spacing, uiColors } from "../library/theme";
import LessonListContainer from "./LessonListContainer";
import Video from "./Video";
import Spinner from "../library/Spinner";
import AnnotationsContainer from "../annotations/AnnotationsContainer";
import AttachmentListContainer from "../attachments/AttachmentListContainer";
import CommentsContainer from "../comments/CommentsContainer";
import { Grid, Sidebar, Icon, Tab, SidebarPusher } from "semantic-ui-react";
import Button from "../library/Button";
import Link from "../library/Link";
import Rating from "../library/Rating";
import { getChatUrl } from "../../utils/formatVideoCode";
import Chat from "./Chat";
import AddolcireChat from "../library/AddolcireChat";

const contentStyle = {
  paddingTop: "20px",
};
const sidebarStyle = {
  minHeight: "100vh",
};
const gridColumnStyle = {
  maxHeight: `calc(100vh - 90px)`,
  overflowY: "auto",
};
const sidebarPushableStyle = {
  height: `calc(100vh - 90px)`,
  overflowY: "hidden",
};
const titleClass = css({ margin: 0 });
const titleAndButtonWrapper = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: spacing.m,
  backgroundColor: uiColors.background,
});
const titleSidebarStyle = { padding: 0, margin: 0 };
const annotationsColumnStyle = { textAlign: "right", paddingBottom: spacing.m };
const descriptionStyle = { paddingTop: spacing.m, fontWeight: "normal" };
const butonsWrappper = css(titleAndButtonWrapper, {
  padding: 0,
  marginTop: spacing.m,
  marginBottom: spacing.m,
});
const annotationsIconClass = css({
  cursor: "pointer",
});

const tabMenu = { color: "red", secondary: true, pointing: true };

export default function Lesson({
  lesson,
  lessonProgressHandler,
  currentClassroomId,
  nextLesson,
  prevLesson,
  progress,
  canRate,
  lessonRatingHandler,
  subscriptionId,
}) {
  const [showSidebar, setShowSidebar] = useState(false);
  const chatUrl = useMemo(() => getChatUrl(lesson), [lesson]);
  const computerSize = lesson?.live ? 9 : 10;

  const toogleSidebar = useCallback(
    () => setShowSidebar(!showSidebar),
    [showSidebar],
  );

  const panes = useMemo(
    () => [
      {
        menuItem: { content: "COMENTÁRIOS", icon: "discussions" },
        render: () => (
          <Tab.Pane attached={false}>
            <CommentsContainer lessonId={lesson.id} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: { content: "ARQUIVOS", icon: "download" },
        render: () => (
          <Tab.Pane attached={false}>
            <AttachmentListContainer title="Arquivos" lessonId={lesson.id} />
          </Tab.Pane>
        ),
      },
    ],
    [lesson?.id],
  );

  return lesson ? (
    <>
      <AddolcireChat />
      <Sidebar.Pushable style={sidebarPushableStyle}>
        <Sidebar
          animation="overlay"
          icon="labeled"
          visible={showSidebar}
          style={sidebarStyle}
          direction="right"
          width="wide"
        >
          <div className={titleAndButtonWrapper}>
            <h3 style={titleSidebarStyle}>Anotações</h3>

            {showSidebar && (
              <Button
                basic
                color="red"
                onClick={toogleSidebar}
                icon="close"
                size="small"
              ></Button>
            )}
          </div>

          <AnnotationsContainer lessonId={lesson.id} />
        </Sidebar>

        <SidebarPusher>
          <Grid columns="equal" padded centered style={contentStyle}>
            {!lesson?.live && (
              <Grid.Column only="computer" computer={5} style={gridColumnStyle}>
                <div className={titleAndButtonWrapper}>
                  <h3 style={titleSidebarStyle}>Aulas</h3>
                </div>
                <LessonListContainer sidebar subscriptionId={subscriptionId} />
              </Grid.Column>
            )}

            <Grid.Column
              computer={computerSize}
              mobile={16}
              style={gridColumnStyle}
            >
              <Grid columns={2} padded>
                <Grid.Column width={14}>
                  <h2 className={titleClass}>{lesson.name}</h2>
                </Grid.Column>
                {!lesson?.live && (
                  <Grid.Column width={2} style={annotationsColumnStyle}>
                    <Icon
                      className={annotationsIconClass}
                      color="red"
                      onClick={toogleSidebar}
                      name="edit outline"
                      size="large"
                    />
                  </Grid.Column>
                )}
              </Grid>
              {lesson.videoUrl && (
                <Video
                  url={lesson.videoUrl}
                  isWatched={lesson.watched}
                  lessonProgressHandler={lessonProgressHandler}
                  progress={progress}
                />
              )}
              {canRate && (
                <Rating
                  title={"Avalie esta aula"}
                  onRate={lessonRatingHandler}
                />
              )}

              {lesson.description && (
                <div
                  style={descriptionStyle}
                  dangerouslySetInnerHTML={{
                    __html: lesson.description,
                  }}
                ></div>
              )}
              <div className={butonsWrappper}>
                <Link
                  to={`/subscriptions/${subscriptionId}/classrooms/${currentClassroomId}/lessons/${prevLesson?.id}`}
                  component={Button}
                  basic
                  color="red"
                  disabled={!prevLesson}
                >
                  <Icon name="angle left" />
                  Aula Anterior
                </Link>
                <Link
                  to={`/subscriptions/${subscriptionId}/classrooms/${currentClassroomId}/lessons/${nextLesson?.id}`}
                  component={Button}
                  basic
                  color="red"
                  disabled={!nextLesson}
                >
                  Próxima Aula
                  <Icon name="angle right" />
                </Link>
              </div>
              <Tab menu={tabMenu} panes={panes} />
            </Grid.Column>

            {lesson?.live && (
              <Grid.Column computer={7} mobile={16}>
                <Chat url={chatUrl} />
              </Grid.Column>
            )}
          </Grid>
        </SidebarPusher>
      </Sidebar.Pushable>
    </>
  ) : (
    <Spinner text="Carregando informações da aula..." />
  );
}
